/**
 * /reserve/:venueSlug — standalone reservation landing page.
 *
 * Deep-linked from the HustleFoodies newsletter's "Quick Reserve" blocks,
 * the Coffee Commune CTA email, and SMS campaigns. Renders the QuickReserve
 * widget centered with venue context above it.
 */
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import QuickReserve from "./QuickReserve";

const API = process.env.REACT_APP_BACKEND_URL || (typeof window !== "undefined" ? window.location.origin : "");
export default function ReservePage() {
  const { venueSlug } = useParams();
  const [venue, setVenue] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    setVenue(null); setMissing(false);
    axios.get(`${API}/api/reservations/venues/${venueSlug}`)
      .then(({ data }) => setVenue(data))
      .catch(() => setMissing(true));
  }, [venueSlug]);

  if (missing) {
    return (
      <div style={{ maxWidth: 560, margin: "80px auto", textAlign: "center", padding: "0 20px", fontFamily: "Inter, sans-serif" }}>
        <h1 style={{ fontFamily: "Georgia, serif" }}>Venue not found</h1>
        <p style={{ color: "#666" }}>We couldn't find a venue with slug <code>{venueSlug}</code>.</p>
        <Link to="/n/current/brisbane/restaurants" style={{ color: "#C75B3D" }}>← Back to HustleFoodies Brisbane</Link>
      </div>
    );
  }

  const accent = venue?.accent_color || "#C75B3D";

  return (
    <div style={{
      minHeight: "100vh",
      background: `linear-gradient(180deg, #fafaf6 0%, ${accent}11 100%)`,
      padding: "44px 20px 80px",
      fontFamily: "Inter, sans-serif",
    }}>
      <div style={{ maxWidth: 980, margin: "0 auto" }}>
        <Link to="/n/current/brisbane/restaurants"
              style={{ color: "#777", textDecoration: "none", fontSize: 13, letterSpacing: 1 }}>
          ← Back to HustleFoodies
        </Link>
        <div style={{ marginTop: 18, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 48, alignItems: "center" }}>
          <div>
            <div style={{
              fontSize: 11, letterSpacing: 4, textTransform: "uppercase",
              color: accent, fontWeight: 700, marginBottom: 10,
            }}>
              Quick Reserve · powered by HustlePlate
            </div>
            <h1 style={{
              fontFamily: "Georgia, serif", fontSize: 42, lineHeight: 1.1,
              letterSpacing: "-0.6px", color: "#1a1408", margin: "0 0 14px",
            }}>
              Book a table at<br />
              <span style={{ color: accent }}>{venue?.name || venueSlug}</span>
            </h1>
            <p style={{ fontSize: 16, lineHeight: 1.55, color: "#555", margin: "0 0 14px" }}>
              {venue?.address}
            </p>
            <p style={{ fontSize: 14, color: "#777", marginBottom: 18 }}>
              {venue?.hours}
            </p>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, fontSize: 13, lineHeight: 1.9, color: "#444" }}>
              <li>✓ Confirmed instantly — no third-party booking fee</li>
              <li>✓ Booking syncs to your member profile</li>
              <li>✓ Next-step journey planner ready (TransLink coming soon)</li>
            </ul>
          </div>
          <div>
            <QuickReserve venueSlug={venueSlug} accent={accent} title={`Reserve at ${venue?.name || venueSlug}`} />
          </div>
        </div>
      </div>
    </div>
  );
}
